module.exports = __webpack_public_path__ + "static/media/marg1.f645c997.png";